'use client'

import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'
import { themeGet } from '@styled-system/theme-get'

import { addToCalendarButton, legalContent, toasts } from './styles'

export default createGlobalStyle`
  ${styledNormalize}

  html {
    width: 100dvw;
    height: 100dvh;
  }

  body {
    color: ${themeGet('colors.text.body')};
    background-color: ${themeGet('colors.background.screen')};
    font-size: 14px;
    font-family: ${themeGet('fonts.primary')};
    line-height: 20px;
    height: 100dvh;
    width: 100%;
    min-width: 100dvw;
    min-height: 100dvh;
    padding: 0;
    overflow: auto;
    margin: 0;

    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-overflow-scrolling: touch;
  }

  html, body, #root, #root > div {
    margin: 0;
    box-sizing: border-box;
    background-repeat: repeat;
  }

  ::selection {
    background: ${themeGet('colors.primary500')};
    color: white;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  pre {
    border: 1px solid ${themeGet('colors.divider.default')};
    background: ${themeGet('colors.background.block')};
    border-radius: 6px;
    padding: ${themeGet('space.5')}px;
    margin: ${themeGet('space.6')}px auto;
    max-width: 500px;
    text-align: left;
    font-size: ${themeGet('fontSizes.1')}px;
    font-weight: ${themeGet('fontWeights.0')};
    line-height: 24px;
  }

  input, textarea {
    display: block;
    margin: 10px auto;
  }

  button {
    background: none;
    border: none;
    outline: none;
    padding: 0;
    cursor: pointer;
  }

  ${toasts}
  ${addToCalendarButton}
  ${legalContent}
`
